import { render } from "./ViewWidgets.vue?vue&type=template&id=2e0938ae&scoped=true"
import script from "./ViewWidgets.vue?vue&type=script&lang=js"
export * from "./ViewWidgets.vue?vue&type=script&lang=js"

import "./ViewWidgets.vue?vue&type=style&index=0&id=2e0938ae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0938ae"]])

export default __exports__